module.exports = __webpack_public_path__ + "media/img/avatars/profiles/avatar-2-fdb92217d1b11e4765b8737b0955b544.jpg";